<template>
    <div>

        <div class="homepage-loading-container" v-if="loading">
            <div class="col-12 justify-content-center loading-spinner">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ translate.home.loading }}...</span>
                </div>
                <span>{{ translate.home.loading }}...</span>
            </div>
        </div>

        <div class="home-search-wrapper">
            <div class="row">
                <div class="col-12">
                    <h1 class="homepage-heading" v-if="!mietmich && !itr">{{
                            translate.home.welcomeTitle_1
                        }}</h1>
                    <h2 class="homepage-subtitle" v-if="!mietmich && !itr">{{
                            translate.home.welcomeTitle_2
                        }}</h2>
                    <h1 class="homepage-heading" v-if="mietmich && !itr">MietMich wurde zu Erobella.</h1>
                    <p v-if="mietmich && !itr" style="text-align: center;">Mehr Girls, schnellere Website und bessere
                        mobile
                        Erfahrung. Willkommen bei Erobella!</p>
                    <h1 class="homepage-heading" v-if="itr">Intimes Revier wurde zu Erobella.</h1>
                    <p v-if="itr" style="text-align: center;">Mehr Girls, schnellere Website und bessere mobile
                        Erfahrung. Willkommen bei Erobella!</p>
                </div>
                <div class="col-12">
                    <home-search-component @search="showResults"></home-search-component>
                </div>
            </div>

            <div class="home-search-hero-image">
                <img width="650" height="560" alt="hero image"
                     :srcset="`${cdn('images/hero_img_1_2.webp')} 1x, ${cdn('images/hero_img_1_2.webp')} 2x`"
                     :src="cdn('images/hero_img_1_2.webp')">
            </div>
        </div>

        <div class="row d-sm-none homepage-register-block mb-5"
             v-if="currentUser && !isGoldUser(currentUser) && !isSilverUser(currentUser) && !isVipPunter">

<!--            <div class="col-md-12 d-flex flex-column align-items-center" v-if="!currentUser">-->
<!--                <h2>{{ translate.home.advertiseWithUs }}</h2>-->
<!--                <a class="btn btn-outline-primary w-100 btn-advertise-with-us"-->
<!--                   :href="regionRelativeUrl('/users/registration/')">-->
<!--                    {{ translate.home.registerForFreeButton }}-->
<!--                </a>-->
<!--            </div>-->

            <template v-if="currentUser">
                <div class="col-md-12 d-flex flex-column align-items-center"
                     v-if="(isEscort || isVenue) && !isGoldUser(currentUser) && !isSilverUser(currentUser)">
                    <h2>{{ translate.product.upgradeGoldHeader }}</h2>
                    <a class="btn btn-rebrand-primary btn-rebrand-sm w-100 btn-upgrade-gold"
                       :href="regionRelativeUrl(NuxtRoutes.PRODUCTS.BUY_PREMIUM)"
                       @click="trackUpgradeClick(`home_upgrade_gold_${isEscort ? 'escort' : 'venue'}`)">
                        {{ translate.product.upgrade }} {{ translate.product.upgradeGold }}
                    </a>
                </div>

                <div class="col-md-12 d-flex flex-column align-items-center"
                     v-if="isPunter && !isVipPunter">
                    <h2>{{ translate.product.upgradeVipHeader }}</h2>
                    <a class="btn btn-rebrand-primary btn-rebrand-sm w-100 btn-upgrade-vip-punter"
                       :href="regionRelativeUrl('/users/products/punter-vip/')"
                       @click="trackUpgradeClick('home_upgrade_vip_punter')">
                        {{ translate.product.upgrade }} {{ translate.product.upgradeVip }}
                    </a>
                </div>
            </template>
        </div>

        <div class="row home-wrap">
            <div class="col-md-12">
                <h2>
                    <icon-component :icon="starCircle()" width="24px" height="24px" />
                    <span>{{ translate.home.featuredEscorts }}</span>
                </h2>
                <div class="home-escorts-grid">
                    <a class="escorts-grid-entry" v-for="(girl, index) in (homepageGirls || homeGirls)"
                       :key="index"
                       :href="regionRelativeUrl(girl.profile_path)"
                       @click.prevent="onUserClick(girl)">
                        <span class="escorts-grid-entry-title">
                            <b class="text-ellipsis">{{ girl.username }}</b>
                            <span class="text-ellipsis">{{ getUserLocationForSearch(girl) }}</span>
                        </span>

                        <picture v-if="index === 0" class="lozad" :data-iesrc="getFirstNonFSKPhotoUrlIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium')">
                            <source :srcset="getFirstNonFSKPhotoPhotoSrcSetIfCan(girl,'webp', girl.is_venue ? 'l-medium' : 'medium')" type="image/webp">
                            <source :srcset="getFirstNonFSKPhotoPhotoSrcSetIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium')" type="image/jpeg">
                            <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                            <noscript>
                                <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' +
                                    getFirstNonFSKPhotoUrlIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium') +') no-repeat;'" alt="">
                            </noscript>
                        </picture>

                        <picture v-else
                                 class="lozad lazyload-img"
                                 :data-iesrc="getFirstNonFSKPhotoUrlIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium')">
                            <source
                                :srcset="getFirstNonFSKPhotoPhotoSrcSetIfCan(girl,'webp', girl.is_venue ? 'l-medium' : 'medium')"
                                type="image/webp">
                            <source
                                :srcset="getFirstNonFSKPhotoPhotoSrcSetIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium')"
                                type="image/jpeg">

                            <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                            <noscript>
                                <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' +
                                    getFirstNonFSKPhotoUrlIfCan(girl,'jpg', girl.is_venue ? 'l-medium' : 'medium') +') no-repeat;'" alt="">
                            </noscript>
                        </picture>

                    </a>

                </div>

                <div class="home-see-all-escorts" v-if="showSeeAllEscortsButton">
                    <a class="btn btn-rebrand-grey-outline btn-rebrand-sm"
                       :href="regionRelativeUrl(settings.defaultSearchUrl)">
                        {{ translate.home.seeAllModels }}
                    </a>
                </div>
            </div>
        </div>

        <div class="row home-location-grid-wrap home-wrap" v-if="lodash.get(regionData,'homepageLocations.length')">
            <div class="col-md-12">
                <h2>
                    <icon-component :icon="foldedMap()" width="24px" height="24px" />
                    <span>{{ translate.home.featuredLocations }}</span>
                </h2>
                <div class="home-location-grid">
                    <a v-for="location in lodash.get(regionData, 'homepageLocations', [])"
                       :href="location.path"
                       class="location-grid-entry"
                       :is="location.path.length ? 'a' : 'div'"
                       :key="`home-${location.title}-${location.location}`"
                    >
                        <span class="location-grid-entry-title">{{ location.title }} <b>{{ location.location }}</b></span>
                        <picture class="lozad lazyload-img" :data-iesrc="location.imageJpg">
                            <source :srcset="location.imageWebp" type="image/webp">
                            <source :srcset="location.imageJpg" type="image/jpeg">

                            <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                            <noscript>
                                <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' + location.imageWebp +') no-repeat;'" alt="">
                            </noscript>
                        </picture>
                    </a>
                </div>
            </div>
        </div>

        <!-- not present in new design -->
        <div class="row home-wrap" v-if="lodash.get(regionData,'homepageServices.length')">
            <div class="col-md-12">
                <h2><span>{{ translate.home.featuredServices }}</span></h2>
                <div class="home-services-grid-container">
                    <div class="home-services-grid">
                        <a :href="service.path" class="services-grid-entry" v-for="service in lodash.get(regionData, 'homepageServices', [])">
                            <span class="location-grid-entry-title">{{ service.title }}</span>
                            <picture class="lozad lazyload-img" :data-iesrc="service.imageJpg">
                                <source :srcset="service.srcsetWebp" type="image/webp">
                                <source :srcset="service.srcsetJpg" type="image/jpeg">
                                <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                                <noscript>
                                    <img src="" class="lazyload-img lazyload-noscript" :style="'background: url(' + service.imageWebp +') no-repeat;'" alt="">
                                </noscript>
                            </picture>
                        </a>
                    </div>

<!--                    <div class="home-services-grid reverse">-->
<!--                        <a :href="service.path" class="services-grid-entry" v-for="service in servicesForGridReversed">-->
<!--                            <span class="location-grid-entry-title">{{ service.title }}</span>-->
<!--                            <picture class="lozad lazyload-img" :data-iesrc="service.imageJpg">-->
<!--                                <source :srcset="service.srcsetWebp" type="image/webp">-->
<!--                                <source :srcset="service.srcsetJpg" type="image/jpeg">-->
<!--                                <noscript>-->
<!--                                    <img src="" class="lazyload-img lazyload-noscript" :style="'background: url(' + service.imageWebp +') no-repeat;'" alt="">-->
<!--                                </noscript>-->
<!--                            </picture>-->
<!--                        </a>-->
<!--                    </div>-->
                </div>
            </div>
        </div>

        <div class="row home-bottom-text flex-column">
            <img src="/images/erobella_logo_no_space.svg" alt="Logo" width="124" height="16" class="logo"/>
            <div v-if="bottomSeoTextIsHtml" class="w-100 bottom-seo-html" v-html="translate.home.bottomSeoText"></div>
            <template v-else>
                <h2 class="w-100">{{ translate.home.bottomSeoText[0] }}</h2>
                <p v-html="translate.home.bottomSeoText[1]"></p>
                <p v-html="translate.home.bottomSeoText[2]"></p>
                <p v-html="translate.home.bottomSeoText[3]"></p>
                <p v-if="translate.home.bottomSeoText[4]" v-html="translate.home.bottomSeoText[4]"></p>
            </template>
        </div>

    </div>
</template>

<script>
import urlMixin from './mixins/url-mixin.js';
import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import lazyLoadImg from "@/components/mixins/lazyLoadImg";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import IconComponent from "@/components/global/IconComponent.vue";
import {foldedMap, starCircle} from "@/core/constants/icons";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

const data = () => {
    return {
        moment: moment,
        lodash: _,
        homepageGirls: null,
        store: $store,
        NuxtRoutes,
        loading: false,
        mietmich: false,
        itr: false,
        probabilityToSeeYourselfInFeatured: 50,
    }
};

function mounted() {
    this.showCurrentUserInHomeGirls();
    this.initLazyLoading();
}

async function showResults() {
    this.loading = true;

    this.store.commit('setCategory', _.cloneDeep(this.categoryTemp));
    this.store.commit('setCategoryTemp', {});

    this.store.commit('setSearchDoneFromHome', true);
    let path = await this.generateUrl();
    if (!_.isEqual(this.$route.fullPath, path)) {
        this.$router.push({path: path});
    }
}

function onUserClick(user) {
    const profilePath = this.regionRelativeUrl(user.profile_path);
    if (!_.isEqual(this.$route.fullPath, profilePath)) {
        this.$router.push({path: profilePath});
    }
}

function cdn(pathString) {
    const pathArr = pathString.split(',');
    if (pathArr.length > 1) {
        const updatedArr = pathArr.map((path) => {
            return `${process.env.MIX_CDN2_URL}${path.trimStart()}`;
        });
        return updatedArr.join(', ');
    } else {
        return `${process.env.MIX_CDN2_URL}${pathString}`;
    }
}

function showCurrentUserInHomeGirls() {

    if (!this.currentUser) {
        return;
    }

    const premiumValidTill = _.get(this, 'currentUser.escorts_profile.premium_valid_till', false);

    if (!premiumValidTill || !this.moment(premiumValidTill).isAfter(this.moment())) {
        return;
    }

    const homeGirlsIds = _.map(this.homeGirls, g => g.id);
    const userAlreadyInList = _.includes(homeGirlsIds, this.currentUser.id);

    if (userAlreadyInList) {
        return;
    }

    if ((Math.random() * 100) > this.probabilityToSeeYourselfInFeatured) {
        return;
    }

    const randomIndex = Math.floor(Math.random() * 20) + 1;

    const homeGirlsTemp = _.cloneDeep(this.homeGirls);

    homeGirlsTemp[randomIndex] = _.cloneDeep(this.currentUser);

    this.homepageGirls = homeGirlsTemp;
}

function trackUpgradeClick(action) {
    this.captureTrackingEvent(this.currentUser, 'profile_administration', action, 'click');
}

function bottomSeoTextIsHtml() {
    return _.isString(_.get(this.translate, 'home.bottomSeoText'));
}

function showSeeAllEscortsButton() {
    return !_.has(this.regionData, 'sectionsToHide.seeAllEscortsButton');
}

export default {
    components: {IconComponent},
    data,
    mounted,
    created() {
        if (typeof mietmichCookie !== 'undefined') {
            this.mietmich = true;
        }
        if (typeof itrCookie !== 'undefined') {
            this.itr = true;
        }
    },
    mixins: [
        urlMixin,
        userMixin,
        photoMixin,
        lazyLoadImg,
        xtrackingMixin,
        regionsUrlMixin,
    ],
    computed: {
        ...mapState([
            'category',
            'categoryTemp',
            'translate',
            'homeGirls',
            'regionData',
            'settings',
        ]),
        bottomSeoTextIsHtml,
        showSeeAllEscortsButton,
        // servicesForGrid(){
        //     return _.cloneDeep(_.get(this.regionData,'homepageServices',[])).splice(0, 4)
        // },
        // servicesForGridReversed(){
        //     return _.cloneDeep(_.get(this.regionData,'homepageServices',[])).splice(4, 4)
        // }
    },
    methods: {
        starCircle,
        foldedMap,
        showResults,
        onUserClick,
        cdn,
        showCurrentUserInHomeGirls,
        trackUpgradeClick,
    }
};
</script>
